import React from 'react'
import userIcon from '../../assets/ic-user.svg'
// import checkIcon from '../../assets/check.svg'
// import plusIcon from '../../assets/plus.svg'
import styles from './FollowerItem.module.css'
// import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
// import { followUser, unfollowUser } from '../../redux/actions/publicProfile'

const truncate = (input) => {
  return input && input.length > 20 ? `${input.substring(0, 20)}...` : input
}

const FollowerItem = ({
  id,
  avatar,
  name,
  bio,
  mutual,
  // profileRelationId,
  onClose
}) => {
  const history = useHistory()
  // const dispatch = useDispatch()
  // const auth = useSelector(state => state.auth)
  // const userId = auth.user && auth.user.profile && auth.user.profile.id
  // const userToken = auth && auth.token
  const userPhoto = avatar && avatar !== '' ? avatar : userIcon
  // const [follow, setFollow] = useState(mutual)

  const handleUserProfile = () => {
    onClose()
    history.push(`/profile/${id}`)
  }

  // const handleFollowUser = async () => {
  //   if (!userToken) {
  //     localStorage.setItem('gfRedirectPath', window.location.pathname)
  //     return dispatch(authPopup.show())
  //   }

  //   if (follow) {
  //     await dispatch(unfollowUser(profileRelationId, id))
  //     setFollow(false)
  //   } else {
  //     await dispatch(followUser(id))
  //     setFollow(true)
  //   }
  // }

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.userInfo} onClick={handleUserProfile}>
          <img src={userPhoto} alt="profile" className={styles.avatar} />
          <div>
            {truncate(name)}
            <span>{truncate(bio)}</span>
          </div>
        </div>
        {/* <div className={styles.userAction}>
          {id !== userId && (
            mutual ?
              <img src={checkIcon} alt="status" />
              :
              <img src={plusIcon} alt="status" />
          )}
        </div> */}
      </div>
    </>
  )
}

export default FollowerItem